import { jsonStringify } from "../utils/common.utils";

const LOG_ENDPOINT = "/api/log";

const commonMetadata = {
  env: process.env.NEXT_PUBLIC_ENVIRONMENT,
};

const Logger = (level = "error", message, data) => {
  try {
    const payload = {
      level,
      message,
      route: window?.location?.pathname,
      userAgent: navigator?.userAgent,
    };
    
    if(data){
      payload.data = data;
    }

    // Beacon Api because it can handle events even during page unload or breakage or third party routing
    navigator?.sendBeacon?.(
      LOG_ENDPOINT,
      new Blob([jsonStringify(payload)], {
        type: "application/json",
      }),
    ) ||
      fetch(LOG_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        keepalive: true,
        body: jsonStringify(payload),
      }).catch(() => {});
  } catch (err) {
    console.error("Logger error:", err);
  }
};

/**
 * Logger utility for different log levels.
 * @type {Object}
 * @property {Function} info - Logs an info level message
 * @property {Function} error - Logs an error level message
 * @property {Function} warn - Logs a warning level message
 * @property {Function} debug - Logs a debug level message
 * @param {string} message - The log message
 * @param {Object} [metadata={}] - Optional metadata to attach to the log
 */
export const logger = {
  info: (message, metadata) => Logger("info", message, metadata),
  error: (message, metadata) => Logger("error", message, metadata),
  warn: (message, metadata) => Logger("warn", message, metadata),
  debug: (message, metadata) => Logger("debug", message, metadata),
};
